// Grade options for one org programme. Moved from pages/groups/useGroupOptions
// (extract-on-second-consumer: groups + users, filters + forms).
import { useList } from '@refinedev/core';
import { useMemo } from 'react';

import type { APMultiSelectOption } from '@/components/ap/form';
import { attrs, type JsonApiRow } from './jsonApi';

export const useGradeSelect = (programmeId: string | number | undefined) => {
  const { data, isLoading } = useList({
    resource: 'grades',
    filters: [{ field: 'by_org_programme_id', operator: 'eq', value: programmeId }],
    pagination: { pageSize: 25 },
    queryOptions: { enabled: !!programmeId },
  });

  const options = useMemo<APMultiSelectOption[]>(
    () =>
      (data?.data ?? []).map((row: JsonApiRow) => {
        const item = attrs(row);
        return {
          value: item.id ?? (row.id as string | number),
          label: String(item.label ?? item.id),
        };
      }),
    [data?.data]
  );

  return { options, isLoading };
};
